// cannot set "overrides" in .eslintrc.json so we disabled the ESlint for createGlobalStyle
// eslint-disable-next-line
import { createGlobalStyle } from 'styled-components';

import { colors } from 'styles/colors';

import AvenirWoff from './fonts/avenir-kris.woff';
import AvenirWoff2 from './fonts/avenir-kris.woff2';

const GlobalStyle = createGlobalStyle`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  @font-face {
    font-family: 'Avenir';
    src: url(${AvenirWoff2}) format('woff2'),
        url(${AvenirWoff}) format('woff');
		font-display: swap;
		font-weight: normal;
		font-style: normal;
  }

  body {
    font-family: Avenir, Open-Sans, Sans-Serif, Helvetica !important;
    font-style: normal;
    font-size: 14px;
    background: ${colors.offWhite};
  }

  button, input, select, textarea {
		font-family: inherit !important;
  }

	a.active-route {
    background: ${colors.gradientBlue};
    border-radius: 8px;


    > div {
      background: ${colors.white};
      border-radius: 7px;
      font-weight: 600;

      > div {
        background: ${colors.gradientBlue3};
        border-radius: 7px;

        > span {
          background-image: ${colors.gradient};
          background-size: 100%;
					background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          -moz-background-clip: text;
          -moz-text-fill-color: transparent;
        }
      }
    }
  }

	/*
	*
	* react-toastify styles
	*
	*/
  .Toastify__toast--success {
    background: ${colors.green70};
  }

  .Toastify__toast--warning {
    background: ${colors.yellow70};
  }

  .Toastify__toast--error {
    background: ${colors.red80};
  }

	/*
	*
	* react-tippy styles
	*
	*/
  .tooltip {
		background: ${colors.white};
		border-radius: 4px;
		padding: 10px;
		font-weight: 400;
		font-style: normal;
		border: 1px solid ${colors.grey30};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
	}
`;

export default GlobalStyle;
